import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/Home';
import Category from '../views/Category';
import Product from '../views/Product';
import Cart from '../views/Cart';
import Checkout from '../views/Checkout';
import Login from '../views/Login';
import Tagging from '../views/Tagging';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/category/:type',
      name: 'category',
      component: Category,
    },
    {
      path: '/product/:id',
      name: 'product',
      component: Product,
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/Tagging',
      name: 'Tagging',
      component: Tagging,
    }

    /*{
      path: '/electronics',
      name: 'electronics',
      component: Electronics,
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: Mobile,
    },
    {
      path: '/fashion',
      name: 'fashion',
      component: Fashion,
    },
    {
      path: '/games',
      name: 'games',
      component: Games,
    },
    {
      path: '/sports',
      name: 'sports',
      component: Sports,
    },*/
  ],
})




// WEBPACK FOOTER //
// ./src/router/index.js